import React from 'react';
import {images} from "../../constants";
import {SubHeading} from "../../components";

import './Chef.css';

const Chef = () => (
  <div className='app__bg app__wrapper section__padding' id="purpose">
    <div className='app__wrapper_img app__wrapper_img-reverse'>
      <img src={images.chef} alt="chef" />
    </div>

    <div className='app__wrapper_info '>
      <SubHeading title="Chief Developerʻs Word"/>
      <h1 className='headtext__cormorant'>
        What we believe in
      </h1>

      <div className='app__chef-content'>
        <div className='app__chef-content_quote'>
          <img src={images.quote} alt="Quote" />
          <p className='p__opensans'>
We are intentional about giving the best visual experiences to your users          </p>
        </div>
        <p className='p__opensans'>
        Juadebfm is one of the legendary brands inspiring the Nigeria with its breath-taking and innovative designs.
         Our original, rebellious, and simply applied techniques, as seen here on our website is unique, conveying something extra in
          terms of beauty and uniqueness with stunning pictures. In addition, we give unexpected and immersive experiences.
           
</p>
      </div>

      <div className='app__chef-sign'>
        <p>Juadeb Gabriel</p>
        <p className='p__opensans'>Designer & Founder</p>
      </div>
    </div>
  </div>
);

export default Chef;
